module.exports = __webpack_public_path__ + "4bb399efc89b01bdaba669e647d9d061.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/soporte.png
// module id = 144
// module chunks = 0